// extracted by mini-css-extract-plugin
export default {"guests":"styles_guests__7tRjO","guests__tabs":"styles_guests__tabs__S5VhJ","guests__main":"styles_guests__main__fEnfa"};